
































































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import notEmptyFun from '../../utils/notEmptyFun';
import Loading from '../../components/Loading.vue';
import tableModel from '../../components/table/tableModel.vue';
import PmModalBox from '../../components/PmModalBox.vue';
import moment from 'moment';
import { Debounced } from '../../utils/debounced';
@Component({
  components: {
    Loading,
  },
})
export default class CreatePurchase extends Vue {
  private user: any;
  private spinning = false;
  private moment: any = moment;
  private selectDataJson: any = [];
  private queryID: any = '0';
  private dataSource: any = [];
  private debouncedUse: (...args: any[]) => any =  new Debounced().use(this.pullDataSource, 1000);
  private dataJson: any = {
    id: '',
    pmName: '',
    brand: '',
    asin: '',
    productName: '',
    productNumber: '',
    store: '',
    purchaseType: '产品', // 采购类型
    packingType: '', // 包材类型
    purchaseNumber: 0, // 采购数量
    price: 0, // 采购价格
    factoryName: '', // 工厂名字
    demandTime: moment(new Date()).format('YYYY-MM-DD'), // 需求时间
    ads: '', // 邮寄地址
    link: '', // 采购物品设计 链接
    remarks: '', // 备注
  };
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      if (this.$router.currentRoute.query && this.$router.currentRoute.query.id) {
        // 获取信息  自动填写信息
        const id = this.$router.currentRoute.query.id;
        this.queryID = id;
        this.getIDData(id);
      }
      this.getSelectData();
    } else {
      console.log('please login');
      this.$router.push({
        path: '/login',
      });
    }
  }
  private async onSearch(searchText: string) {
    this.debouncedUse(searchText);
  }
  private async pullDataSource(searchText: string) {
    const data: any = await this.getDataSource(searchText);
    const arr: any = [];
    if (data.length > 0) {
      data.forEach((element: any, index: number) => {
        arr.push(element.productName);
      });
      this.dataSource = arr;
    }
  }
  private onSelect(value: string) {
    console.log('onSelect', value);
  }
  private getDataSource(Keyword: string) {
    return new Promise((resolve, reject) => {
      this.spinning = true;
      const that = this;
      const url = '/api/getPmInfoLike';
      const args = {
        pmName: this.dataJson.pmName,
        Keyword,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          console.log(res.data.data);
          resolve(res.data.data);
          // that.dataSource = res.data.data;
          this.spinning = false;
        }
      });
    });
  }
  private async getIDData(id: any) {
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/getPurchaseList';
    const args = {
      id,
    };
    const data = await this.axios.post(url, args);
    const dataJson = data.data.data[0];
    this.dataJson = Object.assign({}, this.dataJson, dataJson);
    this.spinning = false;
  }
  private async getSelectData() {
    const that = this;
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getSelectTracking';
    const args = {
      team: this.user.team,
    };
    this.axios.post(url, args).then((res) => {
      that.selectDataJson = res.data.data;
      that.spinning = false;
    });
  }
  private async handleChange(value: string, type: string, asinType: string) {
    const that = this;
    let args = {};
    if ( type === 'productName' ) {
      args = {
        productName: value,
      };
      await this.getTrackingAll(args);
    } else if ( type === 'productNumber' ) {
      args = {
        productNumber: value,
      };
      await this.getTrackingAll(args);
    } else if ( type === 'pmName' ) {
      const url = '/api/getPMTrackingProAsin';
      args = {
        pmName: value,
      };
      this.axios.post(url, args).then((res) => {
        if (res.data.data) {
          Object.assign(this.dataJson, {
            productName: '',
            productNumber: '',
            asin: '',
            store: '',
            brand: '',
          });
          // 根据pmName 更新 产品名称 和 asin
          that.selectDataJson.splice(2, 1, res.data.data[0]);
          that.selectDataJson.splice(1, 1, res.data.data[1]);
        }
      });
    }
  }
  private getTrackingAll(args: any) {
    return new Promise((resolve, reject) => {
      const that = this;
      // 根据 productNumber 自动填写 其他确认的数据;
      const url = '/api/getTrackingAll';
      this.axios.post(url, args).then((res) => {
        const data = res.data.data[0];
        Object.assign(this.dataJson, {
          pmName: data.pmName,
          productName: data.productName,
          productNumber: data.productNumber,
          asin: data.asin,
          store: data.store,
          brand: data.brand,
        });
        resolve();
      });
    });
  }
  private async createOK() {
    // this.$set(this.dataJson, 'demandTime', moment(this.dataJson.demandTime).format('YYYY-MM-DD'));
    const dataJson = this.dataJson;
    const arr = [ 'pmName', 'brand', 'asin', 'productName', 'productNumber', 'store'];
    if (!notEmptyFun(dataJson, arr)) {
      this.$message.warning('*必填字段不能为空!!!');
      return false;
    }
    this.spinning = true;
    if (this.queryID === '0') {
      const url: string = '/api/saveCreatePurchase';
      const args = dataJson;
      const data = await this.axios.post(url, args);
    } else {
      const url: string = '/api/saveChangePurchase';
      const args = dataJson;
      const data = await this.axios.post(url, args);
    }
    this.spinning = false;
    this.$router.push({
      path: '/flow/ApplyPurchaseList',
    });
  }
  private cancel() {
   this.$router.go(-1);
  }
  private onChange() {
    //
  }
  private onChangeDatePicker() {
    //
  }
  private async getData() {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/getOrderDetails';
    const args = {
    };
    const data = await this.axios.post(url, args);
    this.spinning = false;

  }

}
